// import React, {useEffect, useState} from 'react';
// import Checkbox from '@mui/material/Checkbox';
// import {FormGroup} from "@mui/material";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import {Select} from "antd";
// import axios from "axios";
// import {API_PATH} from "../../components/const";
// import {toast} from "react-toastify";
// import {useHistory} from "react-router-dom";
//
// const AddUser = () => {
//     const [users, setUsers] = useState([])
//     const [departments, setDepartments] = useState([])
//     const [sendData, setSendData] = useState({})
//     const [roles, setRoles] = useState([])
//     let history = useHistory()
//     const getUsers = () => {
//         axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/administrator/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
//             .then(res => {
//                 setUsers(res.data?.items)
//             })
//             .catch(err => {
//                 toast.error("Ошибка")
//             })
//     }
//
//     const getDeps = () => {
//         axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/hr/department/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
//             .then(res => {
//                 setDepartments(res.data?.items)
//             })
//             .catch(err => {
//                 toast.error("Ошибка")
//             })
//     }
//     const getRoles = (val) => {
//         axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/role/get_all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
//             .then(res => {
//                 setRoles(res.data)
//             })
//             .catch(err => {
//                 toast.error("Ошибка")
//
//             })
//     }
//     const sendAll = () => {
//         let bigData = new FormData()
//         bigData.append("role_id", sendData?.role_id)
//         axios.put(API_PATH + "user/company/" + localStorage.getItem('id') + "/update/user/" + sendData?.id, bigData, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
//             .then(res => {
//                 toast.success("Добавлено успешно")
//                 history.push("/main/hr-admin/users")
//             })
//     }
//
//     useEffect(() =>{
//         getUsers()
//         getDeps()
//         getRoles()
//     }, [])
//     return (
//         <div className="edit-user">
//             <div className="progress-link">
//                 <img src="/icon/Icon1.svg" alt="."/>
//                 <img src="/icon/arrowleft.svg" alt="."/>
//                 <span>Пользователи</span>
//                 <img src="/icon/arrowleft.svg" alt="."/>
//                 <span>item</span>
//             </div>
//             <h3 className="edit-user-title font-family-medium">
//                 Добавить нового пользователя
//             </h3>
//             <div className="edit-user-box">
//                 <div className="row">
//                     <div className="col-md-4">
//                         <div className="inputs-boxw">
//                             <label  className="font-family-medium mb-2">Имя и фамилия </label>
//                             <Select
//                                 showSearch
//                                 placeholder="Поиск, чтобы выбрать"
//                                 optionFilterProp="children"
//                                 className="w-100"
//                                 onChange={(e) => setSendData({...sendData, id: e})}
//                                 filterOption={(input, option) => (option?.label ?? '').includes(input)}
//                                 filterSort={(optionA, optionB) =>
//                                     (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
//                                 }
//                                 options={users?.map((item) => {
//                                     return {
//                                         value: item.id,
//                                         label:
//                                         item?.first_name + " " +  item?.last_name
//                                     };
//                                 })}
//                             />
//                         </div>
//                         <div className="inputs-boxw mt-2">
//                                 <label className="font-family-medium">Роли</label>
//                                 <Select
//                                     showSearch
//                                     placeholder="Поиск, чтобы выбрать"
//                                     optionFilterProp="children"
//                                     className="w-100"
//                                     onSearch={getRoles}
//                                     onChange={(e) => setSendData({...sendData, role_id: e})}
//
//                                     filterOption={(input, option) => (option?.label ?? '').includes(input)}
//                                     filterSort={(optionA, optionB) =>
//                                         (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
//                                     }
//                                     options={roles?.map((item) => {
//                                         return {
//                                             value: item.id,
//                                             label: item?.name
//                                         };
//                                     })}
//                                 />
//                         </div>
//                     </div>
//                     {/*<div className="col-md-4">*/}
//                     {/*    <label  className="font-family-medium">Привилегии</label>*/}
//                     {/*    <FormGroup>*/}
//                     {/*        /!*<FormControlLabel control={<Checkbox defaultChecked />} label="Label" />*!/*/}
//                     {/*        <FormControlLabel   control={*/}
//                     {/*            <Checkbox/>*/}
//                     {/*        }*/}
//                     {/*                            label="Добавить нового сотрудника"/>*/}
//                     {/*        <FormControlLabel   control={*/}
//                     {/*            <Checkbox/>*/}
//                     {/*        }*/}
//                     {/*                            label="Изменить информацию о сотруднике"/>*/}
//                     {/*        <FormControlLabel   control={*/}
//                     {/*            <Checkbox/>*/}
//                     {/*        }*/}
//                     {/*                            label="Удалить сотрудника"/>*/}
//                     {/*        <FormControlLabel   control={*/}
//                     {/*            <Checkbox/>*/}
//                     {/*        }*/}
//                     {/*                            label="Посмотреть статистику"/>*/}
//                     {/*        <FormControlLabel   control={*/}
//                     {/*            <Checkbox/>*/}
//                     {/*        }*/}
//                     {/*                            label="Просмотр страницы аудита"/>*/}
//                     {/*        <FormControlLabel   control={*/}
//                     {/*            <Checkbox/>*/}
//                     {/*        }*/}
//                     {/*                            label="Добавление администраторов"/>*/}
//                     {/*        <FormControlLabel   control={*/}
//                     {/*            <Checkbox/>*/}
//                     {/*        }*/}
//                     {/*                            label="Экспорт данных"/>*/}
//                     {/*        <FormControlLabel   control={*/}
//                     {/*            <Checkbox/>*/}
//                     {/*        }*/}
//                     {/*                            label="Импортировать данные"/>*/}
//
//                     {/*    </FormGroup>*/}
//                     {/*</div>*/}
//                     <div className="col-md-4"></div>
//                 </div>
//                 <div className="con-btn">
//                     <button className="font-family-medium" onClick={sendAll}><span>Подтверждать</span></button>
//                     <button className="font-family-medium ml-8" onClick={() => history.goBack()}>Отменить</button>
//                 </div>
//             </div>
//
//         </div>
//     );
// };
//
// export default AddUser;

import React, {useEffect, useState} from 'react';
import {Link, useHistory} from "react-router-dom";
import Calendar from "../Home/Calendar";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {Select, Spin} from "antd";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";
import {de} from "date-fns/locale";

const AddUser = () => {

    let history = useHistory()
    const [loader, setLoader] = useState(false)
    const [sendData, setSendData] = useState({
        phone: "+998751234567"
    })
    const [pic, setPic] = useState(null);
    const [roles, setRoles] = useState([])


    const getRoles = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/role/get_all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setRoles(res.data)
                console.log(res.data)
            })
            .catch(err => {
                toast.error("Ошибка")

            })
    }


    const bigData = new FormData()

    const sendAll = () => {
        setLoader(true)
        if (pic) {
            bigData.append("image", pic?.target?.files[0])
        }
        if (sendData?.first_name) {
            bigData.append("first_name", sendData?.first_name)
        }
        if (sendData?.last_name) {
            bigData.append("last_name", sendData?.last_name)
        }
        if (sendData?.username) {
            bigData.append("username", sendData?.username)

        }
        if (sendData?.email) {
            bigData.append("email", sendData?.email)

        }
        if (sendData?.password) {
            bigData.append("password", sendData?.password)
        }
        if (sendData?.position) {
            bigData.append("position", sendData?.position)

        }
        if (sendData?.date_of_birth) {
            bigData.append("date_of_birth", sendData?.date_of_birth)
        }
        if (sendData?.middle_name) {
            bigData.append("middle_name", sendData?.middle_name)
        }
        if (sendData?.phone) {
            bigData.append("phone", sendData?.phone)
        }
        if (sendData?.role_id) {
            bigData.append("role_id", sendData?.role_id)
        }

        if (pic?.target?.files[0]){
            axios.post(API_PATH + "company/" + localStorage.getItem('id') + "/administrator/create", bigData, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    toast.success("Добавлено успешно")
                    // setSendData({
                    //     "first_name": "",
                    //     "last_name": "",
                    //     "username": "",
                    //     "email": "",
                    //     "password": "",
                    //     "position": "",
                    //     "date_of_birth": "",
                    //     "middle_name": "",
                    //     "phone": "",
                    //     "gender": "",
                    //     "building_id": "",
                    //     "department_id": "",
                    // })
                    setLoader(false)

                    history.push("/main/hr-admin/users")
                })
                .catch(err => {
                    // const jsonString = JSON.stringify(err?.response?.data?.detail);
                    // console.log(JSON.stringify(err?.response?.data?.detail))
                    setLoader(false)

                    toast.error(err?.response?.status + " " + JSON.stringify(err?.response?.data?.detail))
                    // err?.response?.data?.detail[0]?.loc[0]
                })
        } else {
            toast.error("Пожалуйста, выберите изображение")
            setLoader(false)
        }



    }


    const [photo123, setphoto123] = useState("/img/addphoto.png");

    const uploadImg = (event) => {
        setphoto123(URL.createObjectURL(event?.target?.files[0]));
        setPic(event);
    };
    useEffect(() => {
        getRoles()
    }, []);

    return (
        <div className="profile-edit">
            <div className="progress-link">
                <Link to="/main/visitor-home"> <img src="/icon/Icon1.svg" alt="."/></Link>
                <img src="/icon/arrowleft.svg" alt="."/>
                <Link to="/main/hr-admin/employees"> <span>Пользователь</span></Link>
                <img src="/icon/arrowleft.svg" alt="."/>
            </div>

            <div className="profile-header">
                <h3 className="font-family-medium">Информация о новом сотруднике</h3>
                <div className="profile-header-box-update">
                    <div className="row">
                        <div className="col-md-2 text-center">
                            {/*<img src="/img/addphoto.png" alt="."/>*/}
                            {/*<input type="file"*/}
                            {/*       onChange={(e) => setPic(e.target.files[0])}*/}
                            {/*/>*/}
                            <div className="userPhoto">
                                <label htmlFor="userPhoto" id="img1">
                                    {" "}
                                    <img src={photo123} alt=""/>
                                </label>
                                <input
                                    type="file"
                                    onChange={(e) => uploadImg(e)}
                                    id="userPhoto"
                                />
                                <p className="font-family-bold">Фотография</p>
                                {/*<p className="open-sans-semibold">{getText("photo")}</p>*/}
                            </div>
                        </div>
                        <div className="col-md-10">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="inputs-box">
                                        <label className="font-family-medium">Имя </label>
                                        <input type="text" onChange={(e) => setSendData({
                                            ...sendData,
                                            first_name: e.target.value
                                        })}/>
                                    </div>
                                    <div className="inputs-box">
                                        <label className="font-family-medium">Фамилия </label>
                                        <input type="text"
                                               onChange={(e) => setSendData({...sendData, last_name: e.target.value})}/>
                                    </div>
                                    <div className="inputs-box">
                                        <label className="font-family-medium">Отчество </label>
                                        <input type="text" onChange={(e) => setSendData({
                                            ...sendData,
                                            middle_name: e.target.value
                                        })}/>
                                    </div>


                                    <div className="inputs-box">
                                        <label className="font-family-medium">Номер телефона </label>
                                        <input
                                            value={sendData?.phone}
                                            onChange={(e) => setSendData({...sendData, phone: e.target.value})}
                                            type="text"/>
                                    </div>

                                    <div className="inputs-box">
                                        <label className="font-family-medium">Email</label>
                                        <input
                                            onChange={(e) => setSendData({...sendData, email: e.target.value})}
                                            type="text"/>
                                    </div>
                                    <div className="inputs-box">
                                        <label className="font-family-medium">Логин </label>
                                        <input onChange={(e) => setSendData({...sendData, username: e.target.value})}
                                               type="text"/>
                                    </div>
                                    <div className="inputs-box">
                                        <label className="font-family-medium">Парол </label>
                                        <input onChange={(e) => setSendData({...sendData, password: e.target.value})}
                                               type="text"/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="inputs-box">
                                        <label className="font-family-medium">Дата рождения </label>
                                        <input type="date"
                                               onChange={(e) => setSendData({
                                                   ...sendData,
                                                   date_of_birth: e.target.value
                                               })}
                                        />
                                    </div>







                                    <div className="inputs-box">
                                        <label className="font-family-medium">Должность </label>
                                        <input type="text"
                                               onChange={(e) => setSendData({...sendData, position: e.target.value})}/>
                                    </div>


                                    {/*<div className="inputs-box-2">*/}
                                    {/*    <label className="font-family-medium">Роли</label>*/}
                                    {/*    <Select*/}
                                    {/*        showSearch*/}
                                    {/*        placeholder="Поиск, чтобы выбрать"*/}
                                    {/*        optionFilterProp="children"*/}
                                    {/*        className="w-100"*/}
                                    {/*        onSearch={getRoles}*/}
                                    {/*        onChange={(e) => setSendData({...sendData, role_id: e})}*/}

                                    {/*        filterOption={(input, option) => (option?.label ?? '').includes(input)}*/}
                                    {/*        filterSort={(optionA, optionB) =>*/}
                                    {/*            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())*/}
                                    {/*        }*/}
                                    {/*        options={roles?.map((item) => {*/}
                                    {/*            return {*/}
                                    {/*                value: item.id,*/}
                                    {/*                label: item.id + " " +*/}
                                    {/*                    item?.name*/}
                                    {/*            };*/}
                                    {/*        })}*/}
                                    {/*    />*/}
                                    {/*</div>*/}
                                    <div className="inputs-box-2">
                                        <label className="font-family-medium">Роли</label>
                                        <Select
                                            showSearch
                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"
                                            onSearch={getRoles}
                                            onChange={(e) => setSendData({...sendData, role_id: e})}

                                            filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                            filterSort={(optionA, optionB) =>
                                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                            }
                                            options={roles?.map((item) => {
                                                return {
                                                    value: item.id,
                                                    label: item.id + " " +
                                                        item?.name
                                                };
                                            })}
                                        />
                                    </div>


                                </div>

                            </div>
                            <div className="con-btn">
                                <button className="font-family-medium" onClick={sendAll}><span>Подтверждать</span>
                                </button>
                                <button className="font-family-medium ml-8" onClick={() => history.goBack()}>Отменить
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                loader
                    ?

                    <div className="my-loader">
                        <Spin size="large" />
                    </div>
                    :
                    ""
            }

        </div>
    );
};

export default AddUser;
